const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/management_control/EmptyRouterView.vue");
const Home = () => /* webpackChunkName: "Home" */ import("./../views/management_control/Home.vue");
const ManagementControl = () => /* webpackChunkName: "ManagementControlHome" */ import("./../views/management_control/ManagementControlHome.vue");
const ContainerReport = () => /* webpackChunkName: "ContainerReport" */ import("./../views/management_control/ContainerReport.vue");
const Dashboard = () => /* webpackChunkName: "Dashboard" */ import("./../views/management_control/dashboard/Dashboard.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");
const ComgesSidraReport = () => /* webpackChunkName: "ComgesSidraReport" */ import("./../views/management_control/ComgesSidraReport.vue");

export const routes = [
  {
    path: "/management_control",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "managementControlHome",
        component: Home,
      },
      {
        path: "charts",
        name: "ManagementControlCharts",
        component: ManagementControl,
      },
      {
        path: "reporte-interconsultas",
        name: "reportInterconsults",
        component: ContainerReport,
      },
      {
        path: "dashboard",
        name: "managementControlDashboard",
        component: Dashboard,
      },
      {
        path: "documentacion",
        name: "managementControlDocumentation",
        component: Document,
      },
      {
        path: "reporte-comges-sidra",
        name: "managementControlComgesSidraReport",
        component: ComgesSidraReport,
      },
    ],
  },
];
